// src/navigation/components/PrivateRoute.tsx
import React from 'react';

interface PublicAuthRouteProps {
  children: React.ReactNode;
}

export const PublicAuthRoute: React.FC<PublicAuthRouteProps> = ({ children }) => {
  return <>{children}</>;
};
